import React from "react";
import i18n from "i18next";

import { legendItemStyle, legendStyle } from "./style";

export const climateIndexLevelNames = () => [
  i18n.t("levels.veryLow"),
  i18n.t("levels.relativelyLow"),
  i18n.t("levels.relativelyModerate"),
  i18n.t("levels.relativelyHigh"),
  i18n.t("levels.veryHigh"),
];

export const climateIndexLevels = [20, 40, 60, 80, 100];

export const ClimateIndexLegend = ({ title }) => (
  <div style={{ ...legendStyle, right: "", left: "12px", top: "30px" }}>
    <div>
      <b>{title}</b>
    </div>
    <div>
      <span style={legendItemStyle("#4d6dbd")}></span>
      {climateIndexLevelNames()[0]}: 0 &lt; index &lt; 20
    </div>
    <div>
      <span style={legendItemStyle("#509bc7")}></span>
      {climateIndexLevelNames()[1]}: 20 &le; index &lt; 40
    </div>
    <div>
      <span style={legendItemStyle("#f1d55d")}></span>
      {climateIndexLevelNames()[2]}: 40 &le; index &lt; 60
    </div>
    <div>
      <span style={legendItemStyle("#e07069")}></span>
      {climateIndexLevelNames()[3]}: 60 &le; index &le; 80
    </div>
    <div>
      <span style={legendItemStyle("#c7445d")}></span>
      {climateIndexLevelNames()[4]}: 80 &le; index &le; 100
    </div>

    <div>
      <span
        style={{
          marginTop: 10,
          fontSize: "xx-small",
          display: "block",
          float: "left",
          width: "200px",
          lineHeight: 1,
        }}
      >
        © CyStellar, Data from RAIN Project, funded by the European Commission, processed by CyStellar
      </span>
    </div>
  </div>
);
